<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
<!--      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :loading="loading"
        @change="onChange"
      >-->

      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '160%' }"
        :loading="loading"
        @change="onChange"
      >
        <template slot="name" slot-scope="name">
          <span class="font-weight-bold">{{name}}</span>
        </template>
        <template slot="code" slot-scope="code">
          <div>
            <div class="font-weight-bold">{{code}}</div>
          </div>
        </template>
        <template slot="transaction_id" slot-scope="transaction_id">
          <span class="text-wrap">{{transaction_id}}</span>
        </template>
        <template slot="date" slot-scope="date">
          <span class="text-wrap">{{date}}</span>
        </template>
        <template slot="balance_quantity" slot-scope="balance_quantity">
          <span class="font-weight-bold text-wrap">{{balance_quantity}}</span>
        </template>
        <template slot="quantity" slot-scope="quantity">
          <span class="text-wrap">{{quantity}}</span>
        </template>
        <template slot="transaction_type" slot-scope="transaction_type, record">
          <span class="font-weight-bold">{{transaction_type}}</span>
          <a-tag color="blue" class="ml-2" v-if="record.transaction_subtype == 4">Opening Stock</a-tag>
        </template>
        <template slot="order" slot-scope="order">
          <span>{{order == null ? 0 : order.order_no}}</span>
        </template>
<!--        <template slot="brought_by" slot-scope="brought_by">
          <span class="font-weight-bold">{{brought_by}}</span>
        </template>-->
        <template slot="received_by" slot-scope="received_by">
          <span class="font-weight-bold">{{received_by}}</span>
        </template>
        <template slot="issued_by" slot-scope="issued_by">
          <span class="font-weight-bold">{{issued_by}}</span>
        </template>
        <template slot="taken_by" slot-scope="taken_by">
          <span class="font-weight-bold">{{taken_by}}</span>
        </template>
        <template slot="received_student" slot-scope="received_student">
          <span class="font-weight-bold">{{received_student}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
<!--            <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon mr-2"
              @click="showViewModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-eye" />
              </span>
              View
            </a>
            <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <edit-student ref="editStudent" :session="session" @edited="handleTableUpdate"/>
              Edit
            </a>-->
            <a href="javascript:;" v-if="rolesetting.deletable && record.order_id === null" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

<!--    <edit-student ref="editStudent" :session="session" @edited="handleTableUpdate"/> -->
<!--    <student-info :rolesetting="rolesetting" ref="showStudent" :session="session" @updateTable="handleTableUpdate" @editClick="handleEditClickFromView"/>-->
  </div>
</template>
<script>
// import moment from 'moment'
// import EditStudent from '@/components/student/Forms/Edit/index'
// import StudentInfo from '@/components/student/Display/Single/index'
const columns = [
  /* {
    title: 'Roll No',
    className: 'text-left',
    dataIndex: 'enrollment[0].roll_no',
    defaultSortOrder: 'descend',
    // sorter: (a, b) => a.enrollment[0].roll_no.localeCompare(b.enrollment[0].roll_no),
    sorter: (a, b) => getSorting(a, b),
    scopedSlots: { customRender: 'roll_no' },
  }, */
  {
    title: 'Product',
    className: 'text-left text-gray-6 text-wrap',
    dataIndex: 'name',
    width: '20%',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Code',
    className: 'text-left text-wrap',
    dataIndex: 'code',
    width: '10%',
    scopedSlots: { customRender: 'code' },
    sorter: (a, b) => a.code.localeCompare(b.code),
  },
  {
    title: 'Transaction ID',
    className: 'text-left',
    dataIndex: 'transaction_id',
    scopedSlots: { customRender: 'transaction_id' },
    width: '20%',
    sorter: (a, b) => a.transaction_id.localeCompare(b.transaction_id),
  },
  {
    title: 'Date',
    className: 'text-left',
    dataIndex: 'date',
    width: '15%',
    scopedSlots: { customRender: 'date' },
    sorter: (a, b) => a.date.localeCompare(b.date),
  },
  {
    title: 'Bal. Qnty',
    className: 'text-left',
    dataIndex: 'balance_quantity',
    width: '10%',
    scopedSlots: { customRender: 'balance_quantity' },
    sorter: (a, b) => a.balance_quantity.localeCompare(b.balance_quantity),
  },
  {
    title: 'Quantity',
    className: 'text-left',
    dataIndex: 'quantity',
    width: '10%',
    scopedSlots: { customRender: 'quantity' },
    sorter: (a, b) => a.quantity.localeCompare(b.quantity),
  },
  {
    title: 'Type',
    className: 'text-left',
    width: '10%',
    dataIndex: 'transaction_type',
    scopedSlots: { customRender: 'transaction_type' },
    sorter: (a, b) => a.transaction_type - b.transaction_type,
  },
  {
    title: 'Session',
    className: 'text-left text-wrap',
    width: '10%',
    dataIndex: 'session_name',
    sorter: (a, b) => a.session_name.localeCompare(b.session_name),
  },
  {
    title: 'Order No.',
    className: 'text-left',
    width: '10%',
    dataIndex: 'order',
    scopedSlots: { customRender: 'order' },
    sorter: (a, b) => a.transaction_type - b.transaction_type,
  },
  {
    title: 'Price',
    className: 'text-left',
    width: '10%',
    dataIndex: 'price',
    scopedSlots: { customRender: 'price' },
    sorter: (a, b) => a.transaction_type - b.transaction_type,
  },
  /* {
    title: 'Brought By',
    className: 'text-left',
    width: '15%',
    dataIndex: 'brought_by',
    scopedSlots: { customRender: 'brought_by' },
    sorter: (a, b) => a.brought_by - b.brought_by,
  }, */
  {
    title: 'Received By',
    className: 'text-left',
    width: '15%',
    dataIndex: 'received_by',
    scopedSlots: { customRender: 'received_by' },
    sorter: (a, b) => a.received_by - b.received_by,
  },
  {
    title: 'Issued By',
    className: 'text-left',
    width: '15%',
    dataIndex: 'issued_by',
    scopedSlots: { customRender: 'issued_by' },
    sorter: (a, b) => a.issued_by - b.issued_by,
  },
  {
    title: 'Issued To (Staff)',
    className: 'text-left',
    width: '15%',
    dataIndex: 'taken_by',
    scopedSlots: { customRender: 'taken_by' },
    sorter: (a, b) => a.taken_by - b.taken_by,
  },
  {
    title: 'Issued To (Student)',
    className: 'text-left text-wrap',
    width: '15%',
    dataIndex: 'received_student',
    scopedSlots: { customRender: 'received_student' },
    sorter: (a, b) => a.received_student - b.received_student,
  },
  {
    title: 'Remark',
    className: 'text-left text-wrap',
    width: '15%',
    dataIndex: 'remark',
    scopedSlots: { customRender: 'remark' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]
function onChange(sorter) {
  console.log('params', sorter)
}
/* function getSorting(a, b) {
  if (a.enrollment[0].roll_no == null) {
    a.enrollment[0].roll_no = ''
  }
  if (b.enrollment[0].roll_no == null) {
    b.enrollment[0].roll_no = ''
  }
  return a.enrollment[0].roll_no.localeCompare(b.enrollment[0].roll_no)
} */
export default {
  name: 'ProductTransactionsTable',
  components: {
    // EditStudent,
    // StudentInfo,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    session: Number,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  watch: {
    // whenever question changes, this function will run
    loading: function () {
      this.selectedRowKeys = []
    },
  },
  methods: {
    onChange,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.$emit('selectChange', selectedRowKeys)
    },
    /* showViewModal: function(record) {
      this.$eventBus.$emit('openStudentShowModal', record.id)
    },
    handleEditClickFromView(studentId) {
      // this.$refs.editStudent.showModal(studentId)
      this.$eventBus.$emit('openStudentEditModal', studentId)
    },
    showEditModal: function(record) {
      // this.$refs.editStudent.showModal(record.id)
      this.$eventBus.$emit('openStudentEditModal', record.id)
    }, */
    handleTableUpdate: function () {
      this.$emit('updateTable')
    },
    /*  handleDate: function($date) {
     return moment($date).format('DD-MM-YYYY')
   },  */
    onDelete: function(record) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete ${record.first_name} ${record.last_name}?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/inventory/transaction/single/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                // description: record.first_name + ' ' + record.last_name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
